
export const stormSewerStatuses = {
    OK: 1,
    DEFECT: 10,
    REMOVED: 20,
}

export const stormSewerTypes = {
    OPEN_DITCH: 1,
    OPEN_SWALE: 2,
    OPEN_CHANNEL: 3,
    STORMWATER_BASIN: 4,
    STORMWATER_CATCH_BASIN: 5,
    STORMWATER_NETWORK: 6,
    STORMWATER_WETLAND: 7,
    INFILTRATION_TRENCH: 8,
    INFILTRATION_FIELD: 9,
    INFILTRATION_DEPRESSION: 10,
    BROOK: 11,
    WEIR_STRUCTURE: 12,
    RETENTION_BASIN: 13,
    STREAM: 14,
    OUTLET_PIT: 15,
    CULVERT: 16,
    SUBSURFACE_DRAINAGE_MANHOLE: 17,
    SHUTOFF_MANHOLE: 18,
    CONTROL_MANHOLE: 19,
    CONTROL_WEIR: 20,
    INSPECTION_MANHOLE: 21,
    INSPECTION_PIPE: 22,
    FLOOD_CHANNEL: 23,
    COMBINED_DRAINAGE_MANHOLE: 24,
    GUTTER: 25,
    MANHOLE_WITH_WATER_TRAP: 26,
    DETENTION_BASIN: 27,
    OIL_SEPARATOR_CHAMBER: 28,
    OTHER: 29,
    UNKNOWN: 30
}


export const stormSewerMaterial = {
    CONCRETE: 1,
    ELEMENT_MESH: 2,
    DOUBLE_SIDED_STEEL_BEAM: 3,
    STONE: 4,
    FIBERGLASS: 5,
    METAL: 6,
    PLASTIC: 7,
    ARMOR_MESH: 8,
    PIPE_BEAM: 9,
    WOOD: 10,
    STEEL: 11,
    STEEL_BEAM: 12,
    STEEL_MESH: 13,
    CABLE: 14,
    CAST_IRON: 15,
    OTHER: 16,
    UNKNOWN: 17,
}

export const stormSewersMixin = {
    methods: {
        newStormDrain(coord) {
            return {
                id: null,
                material: null,
                position: coord,
                status: null
            }
        },
        convertPositionToXY(drain) {
            if (drain && drain.position && drain.position.lat) {
                return {
                    ...drain,
                    position: {
                        // ...drain.position,
                        x: drain.position.lng, // Assign longitude to x
                        y: drain.position.lat, // Assign latitude to y
                    }
                };
            }
            return drain;
        },
        getMaterialOptions() {
            return [
                {value: stormSewerMaterial.CONCRETE, text: this.$t('materials.concrete')},
                {value: stormSewerMaterial.ELEMENT_MESH, text: this.$t('materials.element_mesh')},
                {value: stormSewerMaterial.DOUBLE_SIDED_STEEL_BEAM, text: this.$t('materials.double_sided_steel_beam')},
                {value: stormSewerMaterial.STONE, text: this.$t('materials.rock')},
                {value: stormSewerMaterial.FIBERGLASS, text: this.$t('materials.glass_fiber')},
                {value: stormSewerMaterial.METAL, text: this.$t('materials.metal')},
                {value: stormSewerMaterial.PLASTIC, text: this.$t('materials.plastic')},
                {value: stormSewerMaterial.ARMOR_MESH, text: this.$t('materials.armor_mesh')},
                {value: stormSewerMaterial.PIPE_BEAM, text: this.$t('materials.pipe_beam')},
                {value: stormSewerMaterial.WOOD, text: this.$t('materials.wood')},
                {value: stormSewerMaterial.STEEL, text: this.$t('materials.steel')},
                {value: stormSewerMaterial.STEEL_BEAM, text: this.$t('materials.steel_beam')},
                {value: stormSewerMaterial.STEEL_MESH, text: this.$t('materials.steel_mesh')},
                {value: stormSewerMaterial.CABLE, text: this.$t('materials.wire')},
                {value: stormSewerMaterial.CAST_IRON, text: this.$t('materials.cast_iron')},
                {value: stormSewerMaterial.OTHER, text: this.$t('materials.other')},
                {value: stormSewerMaterial.UNKNOWN, text: this.$t('common.unknown')},
            ]
        },
        getStatusOptions() {
            return [
                {value: stormSewerStatuses.OK, text: this.$t('storm_sewers.status_ok')},
                {value: stormSewerStatuses.DEFECT, text: this.$t('storm_sewers.status_defect')},
                {value: stormSewerStatuses.REMOVED, text: this.$t('storm_sewers.status_removed')},
            ]
        },
        getStatusString: function (status) {
            switch (status) {
                case stormSewerStatuses.OK:
                    return this.$t('storm_sewers.status_ok')
                case stormSewerStatuses.DEFECT:
                    return this.$t('storm_sewers.status_defect')
                case stormSewerStatuses.REMOVED:
                    return this.$t('storm_sewers.status_removed')
            }
        },
            getSewerTypeOptions() {
            return [
                { value: stormSewerTypes.OPEN_DITCH, text: this.$t('storm_sewers.type_open_ditch')},
                { value: stormSewerTypes.OPEN_SWALE, text: this.$t('storm_sewers.type_open_swale') },
                { value: stormSewerTypes.OPEN_CHANNEL, text: this.$t('storm_sewers.type_open_channel') },
                { value: stormSewerTypes.STORMWATER_BASIN, text: this.$t('storm_sewers.type_stormwater_basin') },
                { value: stormSewerTypes.STORMWATER_CATCH_BASIN, text: this.$t('storm_sewers.type_stormwater_catch_basin') },
                { value: stormSewerTypes.STORMWATER_NETWORK, text: this.$t('storm_sewers.type_stormwater_network') },
                { value: stormSewerTypes.STORMWATER_WETLAND, text: this.$t('storm_sewers.type_stormwater_wetland') },
                { value: stormSewerTypes.INFILTRATION_TRENCH, text: this.$t('storm_sewers.type_infiltration_trench') },
                { value: stormSewerTypes.INFILTRATION_FIELD, text: this.$t('storm_sewers.type_infiltration_field') },
                { value: stormSewerTypes.INFILTRATION_DEPRESSION, text: this.$t('storm_sewers.type_infiltration_depression') },
                { value: stormSewerTypes.BROOK, text: this.$t('storm_sewers.type_brook') },
                { value: stormSewerTypes.WEIR_STRUCTURE, text: this.$t('storm_sewers.type_weir_structure') },
                { value: stormSewerTypes.RETENTION_BASIN, text: this.$t('storm_sewers.type_retention_basin') },
                { value: stormSewerTypes.STREAM, text: this.$t('storm_sewers.type_stream') },
                { value: stormSewerTypes.OUTLET_PIT, text: this.$t('storm_sewers.type_outlet_pit') },
                { value: stormSewerTypes.CULVERT, text: this.$t('storm_sewers.type_culvert') },
                { value: stormSewerTypes.SUBSURFACE_DRAINAGE_MANHOLE, text: this.$t('storm_sewers.type_subsurface_drainage_manhole') },
                { value: stormSewerTypes.SHUTOFF_MANHOLE, text: this.$t('storm_sewers.type_shutoff_manhole') },
                { value: stormSewerTypes.CONTROL_MANHOLE, text: this.$t('storm_sewers.type_control_manhole') },
                { value: stormSewerTypes.CONTROL_WEIR, text: this.$t('storm_sewers.type_control_weir') },
                { value: stormSewerTypes.INSPECTION_MANHOLE, text: this.$t('storm_sewers.type_inspection_manhole') },
                { value: stormSewerTypes.INSPECTION_PIPE, text: this.$t('storm_sewers.type_inspection_pipe') },
                { value: stormSewerTypes.FLOOD_CHANNEL, text: this.$t('storm_sewers.type_flood_channel') },
                { value: stormSewerTypes.COMBINED_DRAINAGE_MANHOLE, text: this.$t('storm_sewers.type_combined_drainage_manhole') },
                { value: stormSewerTypes.GUTTER, text: this.$t('storm_sewers.type_gutter') },
                { value: stormSewerTypes.MANHOLE_WITH_WATER_TRAP, text: this.$t('storm_sewers.type_manhole_with_water_trap') },
                { value: stormSewerTypes.DETENTION_BASIN, text: this.$t('storm_sewers.type_detention_basin') },
                { value: stormSewerTypes.OIL_SEPARATOR_CHAMBER, text: this.$t('storm_sewers.type_oil_separator_chamber') },
                { value: stormSewerTypes.OTHER, text: this.$t('storm_sewers.type_other') },
                { value: stormSewerTypes.UNKNOWN, text: this.$t('storm_sewers.type_unknown') },
            ]
        },
        jsonToItem: function (item) {
            return JSON.parse(JSON.stringify(item))
        }
    }
}
